import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { TableGrid } from '@C/TableGrid';
import services from '@C/Admin/Packages/_utils/data';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import axios from 'axios';
import { authHeader } from '@H';

const ExistingPlans = () => {
  const [existingPlans, setExistingPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const col = [
    {
      name: 'Plan name',
      key: 'name',
    },
    {
      name: 'Package',
      key: 'all',
      formatter(props) {
        return <>{props.package.plan_name}</>;
      },
    },
    {
      name: 'Price',
      key: 'price',
      type: 'currency',
    },
    {
      name: 'Validity',
      key: 'all',
      formatter(props) {
        return <>{props.validity} days</>;
      },
    },
    {
      name: 'Status',
      key: 'all',
      formatter(props) {
        return (
          <>
            {props.is_active ? (
              <span className="--green">Active</span>
            ) : (
              <button
                className="btn btn-link"
                title="Activate plan"
                onClick={() => activatePlan(props)}
              >
                <i className="fa-regular fa-badge-check --green"></i>
              </button>
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getPackages();

    // eslint-disable-next-line
  }, []);

  const getPackages = () => {
    services
      .getExistingPlans()
      .then((response) => {
        const tmp = response.data.data;
        setExistingPlans(tmp);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm plan deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const deleteItem = (item) => {
    const headers = authHeader(1);
    let formData = {
      uuid: item.uuid,
    };
    axios
      .delete(`${process.env.API_URL}/subscription/subscription-plan/`)
      .then(() => {
        toast.success('Plan deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        getPackages();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const enabledActions = [
    {
      action: 'Delete',
      roles: ['Site Admin'],
    },
  ];

  const activatePlan = (item) => {
    const headers = authHeader(1);
    axios
      .put(
        `${process.env.API_URL}/subscription/subscription-plan/`,
        {
          uuid: item.uuid,
        },
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Plan activated successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        getPackages();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  return (
    <>
      <section className="widget full-width list-table">
        <header>
          <h3> Existing Plans </h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper --full">
            {loading ? (
              <DropLoaderLarge />
            ) : (
              <TableGrid
                col={col}
                row={existingPlans}
                enabledActions={enabledActions}
                pagination="disabled"
                enableExport={false}
                onDelete={confirmDelete}
              />
            )}
          </div>
        </main>
      </section>
    </>
  );
};

export default ExistingPlans;
